module.exports = __webpack_public_path__ + "media/country_flags/vi-22383839.png";